module.exports = __webpack_public_path__ + "media/images/pin-white-5fd108c399d0e3d37516d4bc3eb1dbb4.png";